export class AccountReportRequest {
  anio: number;
  mes: number;

  constructor(anio?: number, mes?: number) {
    this.anio = anio || new Date().getFullYear();
    this.mes = mes || new Date().getMonth()+1;
  }
}